/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.CallEventMsg = (function() {

    /**
     * Properties of a CallEventMsg.
     * @exports ICallEventMsg
     * @interface ICallEventMsg
     * @property {string|null} [guid] CallEventMsg guid
     * @property {number|null} [version] CallEventMsg version
     * @property {string|null} [fromGuid] CallEventMsg fromGuid
     * @property {string|null} [toGuid] CallEventMsg toGuid
     * @property {string|null} [houseGuid] CallEventMsg houseGuid
     * @property {CallEventMsg.CallStatus|null} [role] CallEventMsg role
     * @property {string|null} [totalGuids] CallEventMsg totalGuids
     */

    /**
     * Constructs a new CallEventMsg.
     * @exports CallEventMsg
     * @classdesc Represents a CallEventMsg.
     * @implements ICallEventMsg
     * @constructor
     * @param {ICallEventMsg=} [properties] Properties to set
     */
    function CallEventMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CallEventMsg guid.
     * @member {string} guid
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.guid = "";

    /**
     * CallEventMsg version.
     * @member {number} version
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.version = 0;

    /**
     * CallEventMsg fromGuid.
     * @member {string} fromGuid
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.fromGuid = "";

    /**
     * CallEventMsg toGuid.
     * @member {string} toGuid
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.toGuid = "";

    /**
     * CallEventMsg houseGuid.
     * @member {string} houseGuid
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.houseGuid = "";

    /**
     * CallEventMsg role.
     * @member {CallEventMsg.CallStatus} role
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.role = 0;

    /**
     * CallEventMsg totalGuids.
     * @member {string} totalGuids
     * @memberof CallEventMsg
     * @instance
     */
    CallEventMsg.prototype.totalGuids = "";

    /**
     * Creates a new CallEventMsg instance using the specified properties.
     * @function create
     * @memberof CallEventMsg
     * @static
     * @param {ICallEventMsg=} [properties] Properties to set
     * @returns {CallEventMsg} CallEventMsg instance
     */
    CallEventMsg.create = function create(properties) {
        return new CallEventMsg(properties);
    };

    /**
     * Encodes the specified CallEventMsg message. Does not implicitly {@link CallEventMsg.verify|verify} messages.
     * @function encode
     * @memberof CallEventMsg
     * @static
     * @param {ICallEventMsg} message CallEventMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CallEventMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.toGuid);
        if (message.houseGuid != null && message.hasOwnProperty("houseGuid"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.houseGuid);
        if (message.role != null && message.hasOwnProperty("role"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.role);
        if (message.totalGuids != null && message.hasOwnProperty("totalGuids"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.totalGuids);
        return writer;
    };

    /**
     * Encodes the specified CallEventMsg message, length delimited. Does not implicitly {@link CallEventMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CallEventMsg
     * @static
     * @param {ICallEventMsg} message CallEventMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CallEventMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CallEventMsg message from the specified reader or buffer.
     * @function decode
     * @memberof CallEventMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CallEventMsg} CallEventMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CallEventMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CallEventMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.fromGuid = reader.string();
                break;
            case 4:
                message.toGuid = reader.string();
                break;
            case 5:
                message.houseGuid = reader.string();
                break;
            case 6:
                message.role = reader.int32();
                break;
            case 7:
                message.totalGuids = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CallEventMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CallEventMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CallEventMsg} CallEventMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CallEventMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CallEventMsg message.
     * @function verify
     * @memberof CallEventMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CallEventMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            if (!$util.isString(message.toGuid))
                return "toGuid: string expected";
        if (message.houseGuid != null && message.hasOwnProperty("houseGuid"))
            if (!$util.isString(message.houseGuid))
                return "houseGuid: string expected";
        if (message.role != null && message.hasOwnProperty("role"))
            switch (message.role) {
            default:
                return "role: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.totalGuids != null && message.hasOwnProperty("totalGuids"))
            if (!$util.isString(message.totalGuids))
                return "totalGuids: string expected";
        return null;
    };

    /**
     * Creates a CallEventMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CallEventMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CallEventMsg} CallEventMsg
     */
    CallEventMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.CallEventMsg)
            return object;
        var message = new $root.CallEventMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.toGuid != null)
            message.toGuid = String(object.toGuid);
        if (object.houseGuid != null)
            message.houseGuid = String(object.houseGuid);
        switch (object.role) {
        case "WAIT":
        case 0:
            message.role = 0;
            break;
        case "FROM_REJECT":
        case 1:
            message.role = 1;
            break;
        case "TO_REJECT":
        case 2:
            message.role = 2;
            break;
        }
        if (object.totalGuids != null)
            message.totalGuids = String(object.totalGuids);
        return message;
    };

    /**
     * Creates a plain object from a CallEventMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CallEventMsg
     * @static
     * @param {CallEventMsg} message CallEventMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CallEventMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.toGuid = "";
            object.houseGuid = "";
            object.role = options.enums === String ? "WAIT" : 0;
            object.totalGuids = "";
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            object.toGuid = message.toGuid;
        if (message.houseGuid != null && message.hasOwnProperty("houseGuid"))
            object.houseGuid = message.houseGuid;
        if (message.role != null && message.hasOwnProperty("role"))
            object.role = options.enums === String ? $root.CallEventMsg.CallStatus[message.role] : message.role;
        if (message.totalGuids != null && message.hasOwnProperty("totalGuids"))
            object.totalGuids = message.totalGuids;
        return object;
    };

    /**
     * Converts this CallEventMsg to JSON.
     * @function toJSON
     * @memberof CallEventMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CallEventMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * CallStatus enum.
     * @name CallEventMsg.CallStatus
     * @enum {string}
     * @property {number} WAIT=0 WAIT value
     * @property {number} FROM_REJECT=1 FROM_REJECT value
     * @property {number} TO_REJECT=2 TO_REJECT value
     */
    CallEventMsg.CallStatus = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WAIT"] = 0;
        values[valuesById[1] = "FROM_REJECT"] = 1;
        values[valuesById[2] = "TO_REJECT"] = 2;
        return values;
    })();

    return CallEventMsg;
})();

module.exports = $root;
